import React from 'react';
import { convertApiResponseToFormData } from '../utils';
import { CreateFlexiBenefit } from '../Create';
import { useSearchParams } from 'hooks/useSearchParams';
import { useQuery } from 'react-query';
import api from 'api';

export const EditFlexiBenefit = () => {
  const { urlParams } = useSearchParams();
  const salaryComponentId = urlParams.get('componentId');
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: [api.flexibleBenefitComponents.queries.getFlexibleBenefit, salaryComponentId],
    queryFn: () => api.flexibleBenefitComponents.queries.getFlexibleBenefit(salaryComponentId!),
    enabled: !!salaryComponentId,
    select: (data) => {
      return data.payrollGetFlexibleBenefitsComponent.component;
    },
  });

  return (
    <CreateFlexiBenefit
      editData={convertApiResponseToFormData(data)}
      isLoading={isLoading}
      isError={isError}
      onRefresh={refetch}
    />
  );
};
